import { useState } from "react";

export default function SafeImage({
  src,
  alt,
  className = "",
  fallbackText = "Image unavailable",
  ...props
}) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`safe-image-fallback ${className}`}>
        {fallbackText && <span>{fallbackText}</span>}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setFailed(true)}
      onLoad={(e) => {
        if (e.target.naturalWidth === 0) setFailed(true);
      }}
      {...props}
    />
  );
}